import Http from "../../../core/http-axios-react/http/Http";
import { HttpBaseRequest } from "../../../core/HttpRequest";
import { HttpBaseResponse, HttpData } from "../../../core/HttpResponse";
import { IExpenseCategory } from "../ExpenseCategory.type";

export const getListCategoryExpense = async ({
  page,
  perPage,
  keyword,
}: HttpBaseRequest) => {
  const res = await Http.get<HttpBaseResponse<HttpData<IExpenseCategory[]>>>({
    url: "/expense-category",
    params: {
      page,
      perPage,
      keyword,
    },
  });
  return res;
};

export const getDetailCategoryExpense = async ({
  expense_category_id,
}: HttpBaseRequest<{ expense_category_id: string }>) => {
  const res = await Http.get<HttpBaseResponse<IExpenseCategory>>({
    url: "/expense-category/detail",
    params: {
      expense_category_id,
    },
  });
  return res;
};

export const addCategoryExpense = async ({ name }: { name: string }) => {
  const res = await Http.post({
    url: "/expense-category/insert",
    data: {
      name,
    },
  });
  return res;
};

export const updateCategoryExpense = async ({
  name,
  expense_category_id,
}: {
  name: string;
  expense_category_id: string;
}) => {
  const res = await Http.post({
    url: "/expense-category/update",
    data: {
      name,
      expense_category_id,
    },
  });
  return res;
};

export const deleteDetailCategoryExpense = async ({
  expense_category_id,
}: HttpBaseRequest<{ expense_category_id: string }>) => {
  const res = await Http.delete({
    url: `/expense-category/delete?expense_category_id=${expense_category_id}`,
  });
  return res;
};
